import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';

@Component({
  selector: 'app-cinejoy-mobile-footer',
  templateUrl: './cinejoy-mobile-footer.component.html',
  styleUrls: ['./cinejoy-mobile-footer.component.css']
})
export class CinejoyMobileFooterComponent implements OnInit {
  footerList:any;
  header:any;
  copyright:any
  constructor(private service:AdminService) { }

  ngOnInit(): void {
    this.service.getAllFooterSections().subscribe((res:any)=>{
      this.footerList = res.filter((v:any)=> v.section !== 'Header');
      this.header = res.find((v:any)=> v.section == 'Header')
    }, err=>{
      console.log(err)
    })

    this.service.getCopyright().subscribe(data=>{
      this.copyright = data.copyRightText
    })
  }

}
